<template>
  <button
    type="button"
    class="focus:outline-none text-base text-white text-sm py-2.5 px-5 rounded-md bg-priceColor transition duration-200 hover:bg-blue-400 hover:shadow-lg"
    @click="$emit('btnClick', $event)"
  >
    {{ name }}
  </button>
</template>

<script>
export default {
  name: 'app-button',
  props: ['name']
}
</script>

<style/>
